import { render, staticRenderFns } from "./RespondentsList.vue?vue&type=template&id=5d7510e4&scoped=true"
import script from "./RespondentsList.vue?vue&type=script&lang=js"
export * from "./RespondentsList.vue?vue&type=script&lang=js"
import style0 from "./RespondentsList.vue?vue&type=style&index=0&id=5d7510e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7510e4",
  null
  
)

export default component.exports